import React from 'react'
import ReactDOM from 'react-dom'
import TextArea from './components/TextArea.jsx'

let elements = document.getElementsByClassName('megadraft-text-area')
Array.prototype.forEach.call(elements, function(element, index) {
  ReactDOM.render(
    <TextArea
      draftJS={element.dataset.startingText}
      textAreaUpdate={element.dataset.inputToUpdate} />,
    element
  )
})
